// frontend/packs/search.js

/* eslint-disable import/first, import/newline-after-import */

import '../layouts/page/searches-show.css';
import 'components/search/search-sidebar/search-sidebar';
import 'components/search/search-feedback/search-feedback';

import { splitTestEnabled, featureEnabled } from 'lib/helpers';

import { Application } from 'stimulus';
export const search = Application.start(); // eslint-disable-line import/prefer-default-export

import 'components/search/search-filters/search-filters';
import 'components/search/search-results/search-results';

// start split-test: resource_show_modal_view
// Keeping this here, commented out, so it can be uncommented if above split test fails
// import ResourcesGridController from 'components/resources/grid/grid-controller';
// search.register('resources-grid', ResourcesGridController);
// end split-test: resource_show_modal_view

import EzCarouselController from 'components/util/ez-carousel/ez-carousel-controller';
search.register('ez-carousel', EzCarouselController);

import SearchFiltersController from 'components/search/search-filters/search-filters-controller';
search.register('search-filters', SearchFiltersController);

import DurationRangeController from 'components/util/ez-double-range/duration-range-controller';
search.register('duration-range', DurationRangeController);

import SearchLinkController from 'controllers/search-link-controller';
search.register('search-link', SearchLinkController);

import SearchSidebarController from 'components/search/search-sidebar/search-sidebar-controller';
if (splitTestEnabled('vertical-grid-infinite-scroll')) search.register('search-sidebar', SearchSidebarController);

import NumPagerController from 'components/util/num-pager/num-pager-controller';
search.register('ez-num-pager', NumPagerController);

import PartnerPopupController from 'components/partner/partner-popup-controller';
search.register('partner-popup', PartnerPopupController);

import PartnerSponsoredResultsController from 'components/partner/search/sponsored-results/sponsored-results-controller';
search.register('partner-sponsored-results', PartnerSponsoredResultsController);

import PartnerJustifiedSearchController from 'components/partner/search/justified-search/partner-justified-search-controller';
search.register('partner-justified-search', PartnerJustifiedSearchController);

import SearchFeedbackController from 'components/search/search-feedback/search-feedback-controller';
if (featureEnabled('search-feedback-tool')) search.register('search-feedback', SearchFeedbackController);
